import { useEffect, useMemo, useState } from 'react';
import api from './api';
import { PAGE_COPY_DEFAULTS } from './pageCopyDefaults';
import { useTrial, trialSwap } from '../contexts/TrialContext';

const cache = {};

/** Replace {placeholders} with values; unknown keys are left as-is. */
export function fill(text, vars) {
  return String(text ?? '').replace(/\{(\w+)\}/g, (m, k) => (vars && vars[k] != null ? String(vars[k]) : m));
}

/** Admin-editable copy for a student page — defaults first, overrides once loaded (cached per session).
 *  In Trial mode (Admin → Free vs Trial) every "Free" label in the copy reads as the trial tier. */
export function usePageCopy(page) {
  const { trialMode, entryLabel } = useTrial();
  const [c, setC] = useState(() => ({ ...PAGE_COPY_DEFAULTS[page], ...(cache[page] || {}) }));
  useEffect(() => {
    let alive = true;
    api.get(`/api/page-copy/${page}`).then((r) => {
      cache[page] = r.data?.copy || {};
      if (alive) setC({ ...PAGE_COPY_DEFAULTS[page], ...cache[page] });
    }).catch(() => {});
    return () => { alive = false; };
  }, [page]);
  return useMemo(() => {
    if (!trialMode) return c;
    return Object.fromEntries(Object.entries(c).map(([k, v]) => [k, trialSwap(v, entryLabel, true)]));
  }, [c, trialMode, entryLabel]);
}
